<template>

  <div 
    class="uk-container uk-position-relative uk-visible-toggle uk-light" 
    tabindex="-1" 
    uk-slideshow="animation: push; autoplay: true; max-height: 400"
  >
    <ul class="uk-slideshow-items">
      <li v-for="item in slider.items" :key="item.id">
        <div class="uk-card uk-card-default uk-grid-collapse uk-child-width-1-2@s uk-margin" uk-grid>
          <div class="uk-flex-last@s uk-card-media-right uk-cover-container">
            <img :src="api_url + item.media.formats.medium.url" alt="" uk-cover>
            <canvas width="600" height="400"></canvas>
          </div>
          <div>
            <div class="uk-card-body">
              <h1 class="uk-card-title slider-title">{{ item.title }}</h1>
              <p>{{ item.summary }}</p>
              <a 
                v-if="item.page && item.page.slug"
                :href="`/${item.page.slug}`" class="button-link">Conocer más</a>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" uk-slidenav-previous uk-slideshow-item="previous"></a>
    <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" uk-slidenav-next uk-slideshow-item="next"></a>

  </div>

</template>

<script>
import gql from "graphql-tag";
// import VueMarkdownIt from "vue-markdown-it";
export default {
  data() {
    return {
      slider: {},
      api_url: process.env.VUE_APP_STRAPI_API_URL,
    };
  },
  components: {
    // VueMarkdownIt
  },
  apollo: {
    slider: {
      query: gql`
        query SLIDER{
          slider{
            items{
              __typename
              ... on ComponentSliderSlider{
                title
                summary
                media{
                  formats
                }
                page{
                  slug
                }
              }
            }
          }
        }
      `
    }
  }
}
</script>

<style scoped>
  @media (min-width: 960px){
    .uk-section {
        padding-top: 0px;
        padding-bottom: 70px;
    }
  }

  .slider-title{
    font-size: 2em;
  }
  .button-link{
    border: 1px solid #ff834fff;
    color: #333;
    border-radius: 30px;
    padding: 10px 20px;
    text-transform: uppercase;
    position: absolute;
    bottom: 50px;
  }
  .button-link:hover{
    color: #000;
  }
</style>